/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {TwoColorIconProps} from '../IconTypes';

/**
 * ![ShopCircleIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB/UlEQVR4nN2UTWsUQRCGVyFRD2JA9OSvEDMT6A5eV5yu6jm0VaCyt70L3vcgqyGi+IH+C496EGMCEkP8B7PGW0y8GIguEbxEaiYJ89E7O8Y92VDsbtf0+3S9VbOt1n+1ADgE5DWD9Bss7wPSB9k3llfT3/ko5dIzSB8B+IpXPI5vXQRLu2WhloDL4rU52rH29vkKIEK621yE63PAd6r2WH43MQDS24J4r9c7aZD3JgUwyHuimWecAEvD6oO0lYogb3uENjMAffP0YSiaJYvohecmi+mkIC96bLifTRE9rub4ZaUH7Xb7lEF6apC/y83B8kPZk1y3250yyA8O9jfBcl/2JHe10zltkB9lldAOWHp2eG7sMpYig7wRWbpWGYqYrwPSF/lsJJZ5TStyA6kEkD8V7LK8KlaldskLVezVukF+AsjPAfnNaMCIaYFRkTW/F8U3LjvnziB2ZtrOXZgMAPmVc+5cY3vqAMbS6zi+eenoOYCzh98/B/OYBGplEKqhRBLo5cGcMn8FiHPi+ZUEemEQ6n1/qH5jQMuz5OajxQ9iVkfHBiSpLfWAJNTvjw0YBOrn2AoC/aNwyFj6OklAEurdcgULzS3Sy2MrCNVS4ZBzbloghUqQfnkrmFNmbAXBfPO/ES8kVP0a/+/9k/gRZFZHMi1pT9K+qKX8zf8AC5iF7Y5XMYUAAAAASUVORK5CYII=)
 */
export const ShopCircleIcon = ({
  size = 'md',
  width,
  height,
  secondaryColor = tokens.colors.STATUS_DANGER,
  secondaryColorClass = '',
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: TwoColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <circle
        cx="19"
        cy="19"
        r="5"
        fill={typeof secondaryColor === 'string' ? secondaryColor : secondaryColor.css}
        className={secondaryColorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M5.52 2a3 3 0 0 0-2.89 2.19l-.55 1.98A3.02 3.02 0 0 0 4.98 10h.05A2.97 2.97 0 0 0 8 7.03V3a1 1 0 0 0-1-1H5.52ZM9 3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4.03a2.99 2.99 0 0 1-3.3 2.95A3 3 0 0 1 9 7V3ZM17 2a1 1 0 0 0-1 1V7.03A2.95 2.95 0 0 0 18.96 10h.06c2 0 3.44-1.9 2.9-3.83l-.56-1.98A3 3 0 0 0 18.48 2H17Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M20.35 12.13c.33.06.65-.18.65-.51v-.2c0-.18-.2-.3-.37-.24a4.46 4.46 0 0 1-4.94-1.1.28.28 0 0 0-.4 0 4.49 4.49 0 0 1-6.58 0 .28.28 0 0 0-.4 0 4.45 4.45 0 0 1-4.94 1.1c-.17-.07-.37.06-.37.24V19a3 3 0 0 0 3 3h2.75c.14 0 .25-.11.25-.25V16c0-1.1.9-2 2-2h2a2 2 0 0 1 .55.08c.21.06.45.02.6-.13a6.98 6.98 0 0 1 6.2-1.82Z"
        className={colorClass}
      />
    </svg>
  );
};
